import React from 'react';
import './HackathonBanner.css';

const HACKATHON_URL = '/hackathon';

export default function HackathonBanner(): React.ReactElement {
  return (
    <aside className="hackathon-banner" aria-label="Alpha Trading Competition announcement">
      <a className="hackathon-banner__link" href={HACKATHON_URL}>
        <span className="hackathon-banner__label">BotSpot Alpha Trading Competition</span>
        <span className="hackathon-banner__message">Build the best trading bot. Win prizes.</span>
        <span className="hackathon-banner__cta" aria-hidden="true">
          See prizes &amp; enter
          <span className="hackathon-banner__cta-arrow">→</span>
        </span>
      </a>
    </aside>
  );
}
